import { request } from 'graphql-request';
import Config from '@annunciate/core/dist/utils/config';
import { CHANNEL_SITEMAP_GET } from '@annunciate/query';
import { DEFAULT_NAV } from './navigation';
const endpoint = `${Config.API_HOST}/graphql`;
export async function getSiteMapData(channelId = 'DEFAULT') {
    const { channel, siteMap } = await request(endpoint, CHANNEL_SITEMAP_GET, { id: channelId });
    return {
        urls: siteMap?.urls,
        nav: channel?.settings?.nav || DEFAULT_NAV,
    };
}
//# sourceMappingURL=getSiteMapData.js.map